import React, { useState, useEffect } from 'react'
import { useTranslate, useNotify, useRefresh, useRecordContext, useShowController } from 'react-admin'
import EditIcon from '@mui/icons-material/Edit'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import EventIcon from '@mui/icons-material/Event'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive'
import { hepstarAncillaryService } from 'src/services/reservation/item/hepstarAncillary.service'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TableContainer,
  Table,
  TableBody,
  Button,
  TextField,
  Backdrop,
  CircularProgress,
  MenuItem,
  Menu,
  TableRow,
  TableCell,
  TableHead,
  Collapse,
  IconButton,
  Chip,
  Select,
  FormControl,
  Tooltip,
  Checkbox,
} from '@mui/material'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import PhoneIcon from '@mui/icons-material/Phone'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import { AirScaleRow } from 'src/components/pages/sales/reservation/logic/air/AirScaleRow'
import { Passenger } from 'src/components/pages/sales/reservation/logic/common/Passenger'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { blue } from 'src/assets/colors'
import { TabProduct } from 'src/components/pages/sales/reservation/logic/common/TabProduct'
import { ToolbarReservation } from 'src/components/pages/sales/reservation/logic/common/ToolbarReservation'
import { getAirports } from 'src/components/pages/sales/reservation/logic/air/AirScaleRow'
import { handleUpdateContact } from 'src/components/pages/sales/reservation/helper/handleUpdateContact'
import { ContactModal } from 'src/components/pages/sales/reservation/logic/modals/ContactModal'
import { CreateItemSupplierModal } from 'src/components/pages/sales/reservation/logic/modals/CreateItemSupplierModal'
import { ComplementaryItemModal } from 'src/components/pages/sales/reservation/logic/modals/ComplementaryItemModal'
import { PricingAirModal } from 'src/components/pages/sales/reservation/logic/modals/PricingAirModal'
import { handleUpdatePricing } from 'src/components/pages/sales/reservation/helper/handleUpdatePricing'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { deleteItemReservation } from 'src/components/pages/sales/reservation/helper/deleteItemReservation'
import { AirForm } from 'src/components/pages/sales/reservation/logic/air/AirForm'
import { guaranteeItemReservation } from 'src/components/pages/sales/reservation/helper/guaranteeItemReservation'
import { cloneItemReservation } from 'src/components/pages/sales/reservation/helper/cloneItemReservation'
import { afterSalesItemReservation } from 'src/components/pages/sales/reservation/helper/afterSalesItemReservation'
import { Comment } from '@mui/icons-material'
import { itemServices } from 'src/services/reservation/item/item.service'
import { flexibleRateService } from 'src/services/reservation/item/flexibleRate.service';
import { servicePackageService } from 'src/services/reservation/item/servicePackage.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import dayjs from 'dayjs'
import { BillingStatusField } from 'src/components/pages/sales/reservation/logic/common/BillingStatusField'
import {
  PERMISSION_GET,
  PERMISSION_IS_BILLABLE,
  PERMISSION_SHOW,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'
import { NotificationEmails } from 'src/components/pages/sales/reservation/logic/common/NotificationEmails'
import { FilesCard as FilesCardComponent } from '../common/FilesCard'
import { BillingAutomaticField } from '../common/BillingAutomaticField'
import { emitItemReservation } from 'src/components/pages/sales/reservation/helper/emitItemReservation'
import { cancelItemReservation } from 'src/components/pages/sales/reservation/helper/cancelItemReservation'
import { INVOICED } from '../common/state'
import { AIR_DETAIL } from 'src/helper/resourceEntity'
import { retriveItemReservation } from 'src/components/pages/sales/reservation/helper/retriveItemReservation'
import { voidItemReservation } from 'src/components/pages/sales/reservation/helper/voidItemReservation'
import { hasLiquidation, hasNotErrorInliquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'
import { DueDateOfProduct } from '../common/DueDateOfProduct'
import { useReservationInfo } from '../../context/ReservationContext'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { approveRefuseFraudItemReservation } from '../../helper/approveRefuseFraudItemReservation'
import { approveRefuseDebinPayment } from '../../helper/approveRefuseDebinPayment'
import { registerReturn } from '../../helper/registerReturn'
import { ExchangeType } from '../common/ExchangeType'
import { EditOriginValues } from '../common/EditOriginValues'
import { CommentsCardComponent } from '../common/CommentsCardComponent'
import { PostVentaStatus } from '../common/postventaStatus'
import { HistoryCostsDialog } from '../common/HistoryCostsDialog'
import CloseIcon from '@mui/icons-material/Close';
import { ChangeStatusDialog } from '../common/ChangeStatusDialog'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import ArticleIcon from '@mui/icons-material/Article'
import GetAppIcon from '@mui/icons-material/GetApp'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { timeZoneFormat } from '../../helper/argToTimezoneFormat'
import { afterSalesNewReservationItem } from '../../helper/afterSalesNewReservationItem'
import { ChangePaymentStatusDialog } from '../common/ChangePaymentStatusDialog'
import { ChangeBillingStatusDialog } from '../common/ChangeBillingStatusDialog'
import { LoadingButton } from '@mui/lab'


const SupplierAir = () => {
  const flight = useRecordContext()
  const translate = useTranslate()

  const getSupplier = () => {
    return flight.supplier_relation?.name || flight?.airline || ''
  }

  return <ShowElement data={getSupplier()} label={translate('ra.field.provider')} />
}

const PassengerAir = ({ reservation }) => {
  const flight = useRecordContext()
  const translate = useTranslate()

  const getTitularPassenger = () => {
    if (reservation?.passenger) {
      return reservation?.passenger
    } else {
      const passenger = flight?.pax_relation?.find((elem) => elem.is_titular)
      return passenger ? `${passenger.name} ${passenger.surname}` : ''
    }
  }

  return <ShowElement data={getTitularPassenger()} label={translate('ra.field.passenger')} />
}

const ReserveInformation = ({reservation, refresh, isBillable, hashItemReserve, setHashItemReserve, setIsBillable}) =>{
  const translate = useTranslate()
  const notify = useNotify()
  const [changeStatusDialog, setChangeStatusDialog] = useState(false)
  const [changePaymentStatusDialog, setChangePaymentStatusDialog] = useState(false)
  const [changeBillingStatusDialog, setChangeBillingStatusDialog] = useState(false)
  const air = useRecordContext()

  const [openDebinModal, setOpenDebinModal] = useState(false)
  const [confirmDebin, setConfirmDebin] = useState(false)
  const [approveDebin, setApproveDebin] = useState(false)
  const [loadingDebinItem, setLoadingDebinItem] = useState(false)
  const [loadingBillable, setLoadingBillable] = useState(false)

  const {
        isFetching
      } = useShowController()

  useEffect(() => {
    if (confirmDebin) {
      approveRefuseDebinPayment({
        hashItemReserve,
        approveDebin,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingDebinItem,
        setConfirmDebin,
        setOpenDebinModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDebin])

  const onChangeBillable = async () =>{
    const newValue = isBillable != undefined ? !isBillable: !air?.is_billable
    setIsBillable(newValue)
    setLoadingBillable(true)
    await reservationServices.updateIsBillableProduct(air.hash_, newValue).then(()=>{
      notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
    }).catch(()=>{
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
    }).finally(()=>{
      setLoadingBillable(false)
    })
  }

  return (
    <ShowCard iconHeader={<EventIcon />} title={translate('ra.title.reserve_information')}>
      <CompleteSideCard>
        <Box display={'flex'}>
          <LeftSideCard style={{ paddingRight: 10 }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', whiteSpace: 'nowrap' }}>
              <ShowElement source='status' label={translate('ra.field.status')} />
              <HasPermission resource={'item'} permission='edit_status'>
                <EditIcon onClick={() => setChangeStatusDialog(true)} style={{ cursor: 'pointer', fontSize: '18px', color: '#6f7ce0', marginLeft: '15px' }} />
              </HasPermission>
            </div>
            <ShowElement
              source='created_at'
              label={translate('ra.field.created_at')}
              dateFormatCustom={timeZoneFormat}
            />
            <ShowElement
              source='issuance_datetime'
              label={translate('ra.field.date_emision')}
              dateFormatCustom={timeZoneFormat}
              nullNoShow={true}
            />
            <ShowElement
              source='source_relation.short_name'
              label={translate('ra.field.source')}
            />
            <HasPermission resource={'business-rule'} permission='view'>
              <ShowElement
                source='product.long_name'
                label={translate('ra.field.product')}
              />
            </HasPermission>
          </LeftSideCard>
          <RigthSideCard>
            {/* <ShowElement
              source={'payment_status'}
              label={translate('ra.field.payment_status')}
              status
              loading={loadingFraudItem}
              onSelectOption={(train_segment, option) => {
                setOpenFraudModal(true)
                setHashItemReserve(train_segment?.hash_)
                setApproveFraud(option === 'approve')
              }}
            /> */}
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
              <ShowElement
                source={'payment_status'}
                label={translate('ra.field.payment_status')}
                status
                onSelectOption={(air_segment, option) => {
                  setHashItemReserve(air_segment?.hash_)
                }}
              />
              <HasPermission resource={'item'} permission='edit_payment_status'>
                <EditIcon onClick={()=>setChangePaymentStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
              </HasPermission>
            </div>
            <PassengerAir reservation={reservation} />
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
              <BillingStatusField />
              <HasPermission resource={'billing'} permission='edit_status'>
                <EditIcon onClick={()=>setChangeBillingStatusDialog(true)} style={{cursor:'pointer', fontSize:'17px', color:'#6f7ce0', marginLeft:'12px'}}/>
              </HasPermission>
            </div>

            {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
              <Box style={{padding: '5px 0px 5px 0px'}}>
                <Typography
                    variant='h7'
                    component='span'
                    style={{
                      padding: '0px 5px 0px 5px',
                      fontWeight: 600,
                      flex: 1,
                      maxWidth: 'fit-content',
                      display: 'inline-flex', 
                      alignItems: 'center',    
                      gap: '6px' 
                    }}
                  >
                  {translate('ra.field.is_billable')}
                  <Checkbox
                      checked={isBillable != undefined?isBillable:air?.is_billable}
                      onChange={onChangeBillable}
                      disabled={loadingBillable || isFetching}
                    />
                    {isFetching && (
                      <CircularProgress size={'10px'} sx={{ marginX: '5px' }} />
                    )}
                </Typography>
              </Box>
            )}
            <BillingAutomaticField />
          </RigthSideCard>
        </Box>
        <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
          {translate('ra.title.provider_info')}
        </Typography>
        <Box display={'flex'}>
          <LeftSideCard style={{ paddingRight: 10 }}>
            <SupplierAir />
            <ShowElement
              source='pricing_relation.[0].currency_origin'
              label={translate('ra.field.currency')}
            />
          </LeftSideCard>
          <RigthSideCard>
            <ShowElement source={'pnr_code'} label={translate('ra.field.provider_code')} />
          </RigthSideCard>
        </Box>
      </CompleteSideCard>
      <ChangeStatusDialog
          open={changeStatusDialog}
          setOpen={setChangeStatusDialog}
          refresh={refresh}
        />
      <ChangePaymentStatusDialog
        open={changePaymentStatusDialog}
        setOpen={setChangePaymentStatusDialog}
        refresh={refresh}
      />
      <ChangeBillingStatusDialog
        open={changeBillingStatusDialog}
        setOpen={setChangeBillingStatusDialog}
        refresh={refresh}
      />

    </ShowCard>
  )
}

const ContextAir = ({ reservation }) => {
  const air = useRecordContext()

  air?.segments?.[0]?.itineraryGroup?.forEach((elem) => {
    const departureDate =
      elem.departureDate && elem.departureTime ? dayjs(`${elem.departureDate} ${elem.departureTime}`) : null
    const arrivalDate =
      elem.arrivalDate && elem.arrivalTime ? dayjs(`${elem.arrivalDate} ${elem.arrivalTime}`) : null
    const timeMin = departureDate && arrivalDate ? arrivalDate.diff(departureDate, 'minute') : null
    const hours = timeMin ? Math.floor(timeMin / 60) : null
    const minutes = timeMin ? timeMin - hours * 60 : null
    elem.totalDuration = hours !== null && minutes !== null ? `${hours} hora(s) ${minutes} minuto(s)` : null
  })

  if (air) {
    return (
      <>
        <HasPermission permission={PERMISSION_SHOW} resource={DUE_DATE_RANGE_PERMISSION_ENTITY}>
          <DueDateOfProduct />
        </HasPermission>
        <AirScaleRow air={air} />
        <Passenger
          itemId={air.item_id}
          passengers={air?.pax_relation}
          idResource={reservation?.id}
          hashItemReserve={air?.hash_}
          resource={AIR_DETAIL}
          status={air?.status}
        />
      </>
    )
  }
}

const ContextAirForm = ({ reservation, openProductModal, onSubmitProduct, setOpenProductModal }) => {
  const air = useRecordContext()
  if (air && openProductModal) {
    return (
      <AirForm
        openModal={openProductModal}
        reservation={reservation}
        passengers={reservation?.passengers}
        workUnit={reservation.work_unit_relation}
        product={air}
        handleClose={() => setOpenProductModal(false)}
        onSubmit={(data, cardId) => onSubmitProduct(data, cardId)}
        recordProduct={air}
      />
    )
  }
}

const ObservationsCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  if (item && item.observations) {
    return (
      <ShowCard iconHeader={<Comment />} title={translate('ra.title.observations')} variant='text'>
        <CompleteSideCard>
          <ShowElement source='observations' onlyValue />
        </CompleteSideCard>
      </ShowCard>
    )
  }
}

const HepstarServicesCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  const [expandedRows, setExpandedRows] = useState({})
  const [openCancelModal, setOpenCancelModal] = useState(false)
  const [selectedAncillary, setSelectedAncillary] = useState(null)
  const [loadingCancel, setLoadingCancel] = useState(false)
  const notify = useNotify()
  const refresh = useRefresh()

  if (!item?.has_ancillary_hepstar || !item?.ancillaries || item.ancillaries.length === 0) {
    return null
  }

  const handleExpandRow = (ancillaryId) => {
    setExpandedRows(prev => ({
      ...prev,
      [ancillaryId]: !prev[ancillaryId]
    }))
  }

  const handleStatusChange = async (ancillary, newStatus) => {
    // newStatus viene en inglés (CONFIRMED, CANCELLED, PENDING)
    // Convertimos a español para mostrar el modal
    const statusInSpanish = getStatusDisplay(newStatus)
    
    if (statusInSpanish === 'CANCELADO') {
      // CANCELADO requiere confirmación especial
      setSelectedAncillary(ancillary)
      setOpenCancelModal(true)
    } else if (statusInSpanish === 'CONFIRMADO' || statusInSpanish === 'PENDIENTE') {
      // CONFIRMADO y PENDIENTE se actualizan directamente
      try {
        await hepstarAncillaryService.updateStatus(ancillary.id, newStatus)
        notify(`Estado actualizado a ${statusInSpanish} exitosamente`, { type: 'success' })
        refresh() // Recargar los datos para mostrar el nuevo estado
      } catch (error) {
        notify(`Error al actualizar el estado a ${statusInSpanish}`, { type: 'error' })
        console.error('Error updating Hepstar ancillary status:', error)
      }
    }
  }

  const getStatusDisplay = (status) => {
    const statusMap = {
      'CONFIRMED': 'CONFIRMADO',
      'CANCELLED': 'CANCELADO', 
      'PENDING': 'PENDIENTE'
    }
    return statusMap[status] || status
  }

  const getStatusColor = (status) => {
    const displayStatus = getStatusDisplay(status)
    switch (displayStatus) {
      case 'CONFIRMADO':
        return 'success'
      case 'CANCELADO':
        return 'error'
      case 'PENDIENTE':
        return 'warning'
      default:
        return 'default'
    }
  }

  const handleCancelConfirm = async () => {
    if (!selectedAncillary) return
    
    setLoadingCancel(true)
    try {
      await hepstarAncillaryService.updateStatus(selectedAncillary.id, 'CANCELLED')
      notify('Ancillary cancelado exitosamente en Hepstar', { type: 'success' })
      refresh() // Recargar los datos para mostrar el nuevo estado
      setOpenCancelModal(false)
      setSelectedAncillary(null)
    } catch (error) {
      notify('Error al cancelar el ancillary en Hepstar', { type: 'error' })
      console.error('Error cancelling Hepstar ancillary:', error)
    } finally {
      setLoadingCancel(false)
    }
  }

  const openTermsAndConditions = (purchase) => {
    if (purchase.terms_and_conditions_url) {
      window.open(purchase.terms_and_conditions_url, '_blank')
    }
  }

  const openVoucher = (purchase) => {
    if (purchase.voucher_url) {
      window.open(purchase.voucher_url, '_blank')
    }
  }

  return (
    <ShowCard iconHeader={<AddCircleIcon />} title="Servicios Adicionales - Hepstar">
      <CompleteSideCard>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Producto</TableCell>
                <TableCell>Código</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell width="40px" align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {item.ancillaries.map((ancillary) => (
                <React.Fragment key={ancillary.id}>
                  <TableRow hover sx={{ backgroundColor: '#f5f5f5' }}>
                    <TableCell>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          fontWeight: 'bold', 
                          cursor: 'pointer',
                          color: 'primary.main',
                          '&:hover': {
                            textDecoration: 'underline'
                          }
                        }}
                        onClick={() => handleExpandRow(ancillary.id)}
                      >
                        {ancillary.product_name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: '500' }}>
                        {ancillary.transaction_code}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <Select
                          value={ancillary.status}
                          onChange={(e) => handleStatusChange(ancillary, e.target.value)}
                          displayEmpty
                          variant="outlined"
                          size="small"
                          sx={{
                            '& .MuiSelect-select': {
                              borderRadius: '5px',
                              padding: '2px 9px',
                              fontSize: '13px',
                              fontWeight: '500',
                              color: 'white',
                              textAlign: 'center',
                              backgroundColor: getStatusDisplay(ancillary.status) === 'CONFIRMADO' ? '#22ee65' : 
                                             getStatusDisplay(ancillary.status) === 'CANCELADO' ? 'red' : 
                                             getStatusDisplay(ancillary.status) === 'PENDIENTE' ? '#ff9800' : '#757575'
                            },
                            '& .MuiSelect-icon': {
                              color: 'white'
                            },
                            '& .MuiOutlinedInput-notchedOutline': { 
                              border: 'none' 
                            },
                            '& .MuiSelect-select:focus': {
                              backgroundColor: getStatusDisplay(ancillary.status) === 'CONFIRMADO' ? '#22ee65' : 
                                             getStatusDisplay(ancillary.status) === 'CANCELADO' ? 'red' : 
                                             getStatusDisplay(ancillary.status) === 'PENDIENTE' ? '#ff9800' : '#757575'
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': { 
                              border: 'none' 
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { 
                              border: 'none' 
                            }
                          }}
                        >
                          <MenuItem value="PENDING">PENDIENTE</MenuItem>
                          <MenuItem value="CONFIRMED">CONFIRMADO</MenuItem>
                          <MenuItem value="CANCELLED">CANCELADO</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <IconButton
                        size="small"
                        onClick={() => handleExpandRow(ancillary.id)}
                        color="primary"
                      >
                        {expandedRows[ancillary.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} sx={{ padding: 0 }}>
                      <Collapse in={expandedRows[ancillary.id]} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1, backgroundColor: '#fafafa', borderRadius: 1, p: 2 }}>
                          <Table size="small">
                            <TableBody>
                              {ancillary.purchases?.map((purchase, index) => (
                                <TableRow key={purchase.id} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' } }}>
                                  <TableCell>
                                    <Box>
                                      <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: '500' }}>
                                        {purchase.purchase_code}
                                      </Typography>
                                    </Box>
                                  </TableCell>
                                  <TableCell>
                                    {purchase.terms_and_conditions_url && (
                                      <Typography
                                        variant="body2"
                                        component="a"
                                        href={purchase.terms_and_conditions_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                          fontWeight: 'bold',
                                          cursor: 'pointer',
                                          color: 'primary.main',
                                          '&:hover': { textDecoration: 'underline' }
                                        }}
                                      >
                                        Ver condiciones
                                      </Typography>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {purchase.voucher_url && (
                                      <Typography
                                        variant="body2"
                                        component="a"
                                        href={purchase.voucher_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                          fontWeight: 'bold',
                                          cursor: 'pointer',
                                          color: 'primary.main',
                                          '&:hover': { textDecoration: 'underline' }
                                        }}
                                      >
                                        Voucher
                                      </Typography>
                                    )}
                                    {!purchase.voucher_url && (
                                      <Typography variant="caption" color="textSecondary">
                                        No disponible
                                      </Typography>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Modal de confirmación de cancelación */}
        <ConfirmationDialog
          title={selectedAncillary ? 
            `¿Está seguro que desea cancelar "${selectedAncillary.product_name}"?` :
            'Confirmar cancelación'
          }
          buttonConfirmText="Sí, cancelar en Hepstar"
          buttonCancel="No, mantener activo"
          setOpen={setOpenCancelModal}
          setConfirm={handleCancelConfirm}
          open={openCancelModal}
          loadingModalButton={loadingCancel}
        >
          {selectedAncillary && (
            <Box sx={{ mt: 2, p: 2, backgroundColor: '#fff3cd', borderRadius: 1 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Código Maestro:</strong> {selectedAncillary.transaction_code}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Purchase Numbers a cancelar:</strong>
              </Typography>
              <Box sx={{ ml: 2 }}>
                {selectedAncillary.purchases?.map((purchase, index) => (
                  <Typography key={purchase.id} variant="caption" sx={{ display: 'block' }}>
                    {index + 1}. {purchase.purchase_code}
                  </Typography>
                ))}
              </Box>
            </Box>
          )}
        </ConfirmationDialog>
      </CompleteSideCard>
    </ShowCard>
  )
}

const FilesCard = () => {
  const translate = useTranslate()
  const air = useRecordContext()
  if (air) {
    return (
      <ShowCard title={translate('ra.title.files')}>
        <FilesCardComponent recordProduct={air} />
      </ShowCard>
    )
  }
}

const LiquidationCards = ({enableReliquidation}) => {
  const translate = useTranslate()
  const item = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [refreshLiquidation, setRefreshLiquidation] = useState(0)
  const [openReliquidateModal, setOpenReliquidateModal] = useState(false)
  const [confirmReliquidate, setConfirmReliquidate] = useState(false)
  const [reliquidateType, setReliquidateType] = useState(0)
  const [reliquidateLoading, setReliquidateLoading] = useState(false)

  const onReliquidate = async () =>{
    setReliquidateLoading(true)
    if(reliquidateType === 0){
      await pricingServices.reliquidate_wholesaler([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 1){
      await pricingServices.reliquidate_retail([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 2){
      await pricingServices.reliquidate_supplier([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    
  }

  useEffect(()=>{
    if(confirmReliquidate){
      onReliquidate()
    }
  },[confirmReliquidate])

  const decideLiquidation = () =>{
    if(reliquidateType === 0){
      return translate('ra.title.liquidation_wholesaler')
    }
    if(reliquidateType === 1){
      return translate('ra.title.liquidation_retail')
    }
    if(reliquidateType === 2){
      return translate('ra.title.liquidation_supplier')
    }
  }

  const handleCLickRule = (ruleId) => {
    if (ruleId) {
      window.open(`/#/business-rule/${ruleId}`, '_blank')
    }
  }

  return (
    <>
      <ExchangeType />
      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_wholesaler) && (
        <HasPermission permission={VIEW_LIQUIDATION_WHOLESALER} resource={'pricing'}>
          <ShowCard
            iconHeader={
              <Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(0)
                    }
                  }}
                />
              </Tooltip>
            }
            title={translate('ra.title.liquidation_wholesaler')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, textAlign: 'end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied}
                  </Button>
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`wholesaler${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_wholesaler' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_retail) &&
        hasNotErrorInliquidation(item?.pricing_relation?.[0]?.liquidation_retail) && (
          <HasPermission permission={VIEW_LIQUIDATION_RETAIL} resource={'pricing'}>
            <ShowCard
              iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation&& translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler')&& enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_retail')&& enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_retail')&& enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(1)
                    }
                  }}
                />
              </Tooltip>}
              title={translate('ra.title.liquidation_retail')}
              posTitle={
                <HasPermission resource={'business-rule'} permission='view'>
                  <Box sx={{ flex: 1, textAlign: 'end' }}>
                    <Button
                      variant='text'
                      onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied)}
                    >
                      {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied}
                    </Button>
                  </Box>
                </HasPermission>
              }
              variant='text'
              optionHeigth={'liquidation'}
            >
              <TableContainer>
                <Table>
                  <TableBody key={`retail${refreshLiquidation}`}>
                    <LiquidationPricing node_liquidation='liquidation_retail' />
                  </TableBody>
                </Table>
              </TableContainer>
            </ShowCard>
          </HasPermission>
        )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_supplier) && (
        <HasPermission permission={VIEW_LIQUIDATION_SUPPLIER} resource={'pricing'}>
          <ShowCard
            iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_supplier')&& enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(2)
                    }
                  }}
                />
              </Tooltip>}
            title={translate('ra.title.liquidation_supplier')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, textAlign: 'end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied}
                  </Button>
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`supplier${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_supplier' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}
      <ConfirmationDialog
        title={decideLiquidation()}
        contentText={translate('ra.message.reliquidation_confirm', {liquidation:decideLiquidation()})}
        buttonConfirmText={translate('ra.message.yes')}
        buttonCancel={translate('ra.message.no')}
        setOpen={setOpenReliquidateModal}
        setConfirm={setConfirmReliquidate}
        open={openReliquidateModal}
        loadingModalButton={reliquidateLoading}
      />
    </>
  )
}

const IsCabotage = () => {
  const translate = useTranslate()
  const air = useRecordContext()
  if (air && air?.is_cabotage !== null && air?.is_cabotage !== undefined) {
    return (
      <ShowElement data={air?.is_cabotage} label={translate('ra.field.cabotage')} boolean />
    )
  }
}

const HasMetaCode = () => {
  const translate = useTranslate()
  const air = useRecordContext()
  if (air && air?.url_meta !== null && air?.url_meta !== undefined) {
    return (
      <ShowElement data={air?.url_meta} label={translate('ra.field.meta_code')} />
    )
  }
}

const HasFareCode = () => {
  const translate = useTranslate()
  const air = useRecordContext()
  if (air && air?.fare_code !== null && air?.fare_code !== undefined) {
    return (
      <ShowElement data={air?.fare_code} label={translate('ra.field.fare_code')} />
    )
  }
}

const FlexibleRateCard = () => {
  const record = useRecordContext();
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();

  const formatDate = date =>
    date ? dayjs(date).format('DD-MM-YYYY') : '';

  // Estado local para controlar el select
  const [status, setStatus] = useState(record.flexible_rate_status);

  const url = record.flexible_rate_data?.terms_and_conditions_url;

  // Mantener opciones únicas
  const options = [
    record.flexible_rate_status,
    'Cancelado',
    'Usado',
  ].filter((s, i, a) => s && a.indexOf(s) === i);

  // Handler que dispara la petición PATCH
  const handleChangeStatus = async (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);
    try {
      await flexibleRateService.updateStatus(record.id, newStatus);
      notify(translate('ra.notification.updated'), { type: 'success' });
      refresh();
    } catch (err) {
      notify(translate('ra.notification.error'), { type: 'warning' });
      // Si falla, volvemos al anterior
      setStatus(record.flexible_rate_status);
    }
  };

  if (!record.flexible_rate_data?.is_selected) {
    return null;
  }

  return (
    <WrapperCardId>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ShowCard
            title={
              <Typography variant="h6" style={{ color: blue }}>
                {translate('ra.title.flexiRate')}
              </Typography>
            }
          >
            <CompleteSideCard>
              <Box
                display="flex"
                alignItems="center"
                gap={25}
                flexWrap="wrap"
              >
                <Box display="flex" alignItems="center" minWidth={200}>
                  <Typography variant="body2" style={{ marginRight: 8 }}>
                    <strong>{translate('ra.field.status')}:</strong>
                  </Typography>
                  <TextField
                    select
                    size="small"
                    value={status}
                    onChange={handleChangeStatus}
                  >
                    {options.map(opt => {
                      let label = opt;
                      if (opt === 'Cancelado') label = translate('ra.status.CANCELLED');
                      if (opt === 'Usado') label = translate('ra.status.USED');
                      return (
                        <MenuItem key={opt} value={opt}>
                          {label}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Box>

                <Typography variant="body2">
                  <strong>{translate('ra.field.from')}:</strong>{' '}
                  {formatDate(record.flexible_rate_data?.check_in)}
                </Typography>
                <Typography variant="body2">
                  <strong>{translate('ra.field.to')}:</strong>{' '}
                  {formatDate(record.flexible_rate_data?.check_out)}
                </Typography>
              </Box>

              <Box marginTop={2}>
                <Button
                  variant="contained"
                  size="small"
                  component="a"
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  disabled={!url}
                  style={{
                    backgroundColor: blue,
                    color: '#fff',
                    marginTop: 10,
                  }}
                >
                  {translate('ra.action.see_conditions')}
                </Button>
              </Box>
            </CompleteSideCard>
          </ShowCard>
        </Grid>
      </Grid>
    </WrapperCardId>
  );
};

const ServicePackageCard = () => {
  const record = useRecordContext();
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();

  const formatDate = date =>
    date ? dayjs(date).format('DD-MM-YYYY') : '';

  // Estado local para controlar el select
  const [status, setStatus] = useState(record.service_package_status);

  const url = record.service_package_data?.terms_and_conditions_url;

  // Sincronizar el estado local cuando el record cambie después del refresh
  useEffect(() => {
    setStatus(record.service_package_status);
  }, [record.service_package_status]);

  // Calcular fechas desde y hasta basado en los vuelos
  const getFlightDates = () => {
    if (!record?.segments?.[0]?.itineraryGroup || record.segments[0].itineraryGroup.length === 0) {
      return { desde: '', hasta: '' };
    }

    const itinerary = record.segments[0].itineraryGroup;
    const firstFlight = itinerary[0];
    const lastFlight = itinerary[itinerary.length - 1];

    // Si solo hay un vuelo (one way), ambas fechas son iguales
    // Si hay más de un vuelo (roundtrip), tomar el primero y el último
    return {
      desde: formatDate(firstFlight.departureDate),
      hasta: formatDate(lastFlight.departureDate)
    };
  };

  const { desde, hasta } = getFlightDates();

  // Mantener opciones únicas
  const options = [
    record.service_package_status,
    'CANCELADO',
    'USADO',
  ].filter((s, i, a) => s && a.indexOf(s) === i);

  // Handler que dispara la petición PATCH
  const handleChangeStatus = async (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);
    try {
      await servicePackageService.updateStatus(record.id, newStatus);
      notify(translate('ra.notification.updated'), { type: 'success' });
      refresh();
    } catch (err) {
      notify(translate('ra.notification.error'), { type: 'warning' });
      // Si falla, volvemos al anterior
      setStatus(record.service_package_status);
    }
  };

  // Solo mostrar si has_service_package es true
  if (!record.has_service_package) {
    return null;
  }

  return (
    <WrapperCardId>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ShowCard
            title={
              <Typography variant="h6" style={{ color: blue }}>
                {translate('ra.title.servicePackage')}
              </Typography>
            }
          >
            <CompleteSideCard>
              <Box
                display="flex"
                alignItems="center"
                justifyContent=""
                gap={25}
                flexWrap="wrap"
              >
                <Box display="flex" alignItems="center" minWidth={200}>
                  <Typography variant="body2" style={{ marginRight: 8 }}>
                    <strong>{translate('ra.field.status')}:</strong>
                  </Typography>
                  <TextField
                    select
                    size="small"
                    value={status}
                    onChange={handleChangeStatus}
                  >
                    {options.map(opt => {
                      let label = opt;
                      if (opt === 'CANCELADO') label = translate('ra.status.CANCELLED');
                      if (opt === 'USADO') label = translate('ra.status.USED');
                      if (opt === 'CONFIRMADO') label = translate('ra.status.CONFIRMED');
                      return (
                        <MenuItem key={opt} value={opt}>
                          {label}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Box>

                <Typography variant="body2">
                  <strong>{translate('ra.field.from')}:</strong>{' '}
                  {desde}
                </Typography>
                <Typography variant="body2">
                  <strong>{translate('ra.field.to')}:</strong>{' '}
                  {hasta}
                </Typography>
              </Box>

              <Box marginTop={2}>
                <Button
                  variant="contained"
                  size="small"
                  component="a"
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  disabled={!url}
                  style={{
                    backgroundColor: blue,
                    color: '#fff',
                    marginTop: 10,
                  }}
                >
                  {translate('ra.action.see_conditions')}
                </Button>
              </Box>
            </CompleteSideCard>
          </ShowCard>
        </Grid>
      </Grid>
    </WrapperCardId>
  );
};

export const AirProduct = ({ reservation, air, editMode = false }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const [nameReserve, setNameReserve] = useState('')
  const [hashItemReserve, setHashItemReserve] = useState('')
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [loadingCancelItem, setLoadingCancelItem] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [loadingDeleteItem, setLoadingDeleteItem] = useState(false)
  const [openGuaranteeModal, setOpenGuaranteeModal] = useState(false)
  const [confirmGuarantee, setConfirmGuarantee] = useState(false)
  const [loadingGuaranteeItem, setLoadingGuaranteeItem] = useState(false)
  const [openMoveModal, setOpenMoveModal] = useState(false)
  const [loadingMoveItem, setLoadingMoveItem] = useState(false)
  const [reservationNumberMove, setReservationNumberMove] = useState('')
  const [openPricingModal, setOpenPricingModal] = useState(false)
  const [loadingPricingModal, setLoadingPricingModal] = useState(false)

  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [confirmClone, setConfirmClone] = useState(false)
  const [loadingCloneItem, setLoadingCloneItem] = useState(false)

  const [openAfterSalesModal, setOpenAfterSalesModal] = useState(false)
  const [openAfterSalesItemModal, setOpenAfterSalesItemModal] = useState(false)
  const [confirmAfterSalesItem, setConfirmAfterSalesItem] = useState(false)
  const [loadingAfterSalesReservationItem, setLoadingAfterSalesReservationItem] = useState(false)
  const [openCreateItemSupplierModal, setOpenCreateItemSupplierModal] = useState(false)
  const [itemSupplierItemId, setItemSupplierItemId] = useState(null)
  const [openComplementaryModal, setOpenComplementaryModal] = useState(false)
  const [loadingComplementaryItem, setLoadingComplementaryItem] = useState(false)
  const [confirmAfterSales, setConfirmAfterSales] = useState(false)
  const [loadingAfterSalesItem, setLoadingAfterSalesItem] = useState(false)

  const [openRegisterReturnModal, setOpenRegisterReturnModal] = useState(false)
  const [confirmRegisterReturn, setConfirmRegisterReturn] = useState(false)
  const [loadingRegisterReturnItem, setLoadingRegisterReturnItem] = useState(false)
  // const [individualRecord, setIndividualRecord] = useState({})
  // const [openLiqudiationPricingModal, setOpenLiqudiationPricingModal] = useState(false)
  // const [loadingLiqudiationPricingModal, setLoadingLiqudiationPricingModal] = useState(false)
  const [openContactModal, setOpenContactModal] = useState(false)
  const [loadingContactModal, setLoadingContactModal] = useState(false)
  // const [exchangeMode, setExchangeMode] = useState(false)
  const [openProductModal, setOpenProductModal] = useState(false)

  const [confirmEmit, setConfirmEmit] = useState(false)
  const [openEmitModal, setOpenEmitModal] = useState(false)
  const [loadingEmitItem, setLoadingEmitItem] = useState(false)
  const [wasEmitted, setWasEmitted] = useState({})

  const [openRetriveModal, setOpenRetriveModal] = useState(false)
  const [loadingRetriveItem, setLoadingRetriveItem] = useState(false)
  const [confirmRetrive, setConfirmRetrive] = useState(false)

  const [confirmVoid, setConfirmVoid] = useState(false)
  const [openVoidModal, setOpenVoidModal] = useState(false)
  const [loadingVoidItem, setLoadingVoidItem] = useState(false)

  const [openFraudModal, setOpenFraudModal] = useState(false)
  const [confirmFraud, setConfirmFraud] = useState(false)
  const [approveFraud, setApproveFraud] = useState(false)
  const [loadingFraudItem, setLoadingFraudItem] = useState(false)

  const [openDebinModal, setOpenDebinModal] = useState(false)
  const [confirmDebin, setConfirmDebin] = useState(false)
  const [approveDebin, setApproveDebin] = useState(false)
  const [loadingDebinItem, setLoadingDebinItem] = useState(false)

  const [historyCostsDialog, setHistoryCostsDialog] = useState()
  const { setOpenDueDateModal } = useReservationInfo()

  const [changePostVentaStatus, setChangePostventaStatus] = useState(false)
  const [loadingPostventaStatus, setLoadingPostventaStatus] = useState(false)
  const [actualStatus, setActualStatus] = useState('')

  const [isBillable, setIsBillable] = useState()

  const [enableReliquidation, setEnableReliquidation] = useState(false)

  const { setCardLoading } = useCardLoading()

  useEffect(() => {
    if (confirmGuarantee) {
      guaranteeItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingGuaranteeItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmGuarantee,
        setOpenGuaranteeModal,
        onGuaranteeSuccess: () => {
          setOpenDueDateModal(true)
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmGuarantee])

  useEffect(() => {
    if (confirmClone) {
      cloneItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCloneItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmClone,
        setOpenCloneModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmClone])

  useEffect(() => {
    if (confirmRegisterReturn) {
      registerReturn({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingRegisterReturnItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmRegisterReturn,
        setOpenRegisterReturnModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRegisterReturn])

  useEffect(() => {
    if (confirmAfterSales) {
      afterSalesItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingAfterSalesItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmAfterSales,
        setOpenAfterSalesModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmAfterSales])

  useEffect(() => {
    if (confirmAfterSalesItem) {
      afterSalesNewReservationItem({
        hashItemReserve,
        refresh,
        notify,
        setLoadingAfterSalesReservationItem,
        setHashItemReserve,
        setConfirmAfterSalesItem,
        setOpenAfterSalesItemModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmAfterSalesItem])

  useEffect(() => {
    if (confirmDelete) {
      deleteItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingDeleteItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmDelete,
        setOpenDeleteModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
    if (changePostVentaStatus) {
      PostVentaStatus({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingPostventaStatus,
        setNameReserve,
        setHashItemReserve,
        setChangePostventaStatus,
        actualStatus
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changePostVentaStatus])

  useEffect(() => {
    if (confirm) {
      cancelItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelItem,
        setNameReserve,
        setHashItemReserve,
        setConfirm,
        setOpen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  useEffect(() => {
    if (confirmEmit) {
      emitItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingEmitItem,
        setNameReserve,
        setConfirmEmit,
        setOpenEmitModal,
        setWasEmitted,
        translate,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmEmit])

  useEffect(() => {
    if (confirmRetrive) {
      retriveItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingRetriveItem,
        setNameReserve,
        setConfirmRetrive,
        setOpenRetriveModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRetrive])

  useEffect(() => {
    if (confirmVoid) {
      voidItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingVoidItem,
        setNameReserve,
        setConfirmVoid,
        setOpenVoidModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmVoid])

  useEffect(() => {
    if (confirmFraud) {
      approveRefuseFraudItemReservation({
        hashItemReserve,
        approveFraud,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingFraudItem,
        setConfirmFraud,
        setOpenFraudModal
      })

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmFraud])

  useEffect(() => {
    if (confirmDebin) {
      approveRefuseDebinPayment({
        hashItemReserve,
        approveDebin,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingDebinItem,
        setConfirmDebin,
        setOpenDebinModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDebin])

  useEffect(() => {
    let wasEmittedKeys = Object.keys(wasEmitted)
    if (air && Array.isArray(air) && air.length > 0 && wasEmittedKeys.length > 0) {
      wasEmittedKeys.forEach((emit) => {
        const isEmmited = air.find((elem) => elem?.hash_ === emit && elem?.status === INVOICED)
        if (wasEmitted[emit] && isEmmited) {
          setWasEmitted((prev) => ({
            ...prev,
            [emit]: false,
          }))
          setLoadingEmitItem(false)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [air, wasEmitted])

  const onSubmitProduct = (data, cardId) => {
    setCardLoading(cardId, true)
  }

  const handleMoveItem = async () => {
    if (reservationNumberMove) {
      setLoadingMoveItem(true)
      try {
        await itemServices.move_item(hashItemReserve, reservationNumberMove, reservation.number)
        notify('ra.notification.move_item_success', {
          type: 'success',
          messageArgs: { item: nameReserve },
        })
      } catch (error) {
        if (error.response.data?.detail) {
          notify(error.response.data?.detail, {
            type: 'error',
          })
        } else {
          notify('ra.notification.move_item_error', {
            type: 'error',
            messageArgs: { item: nameReserve },
          })
        }
      } finally {
        customAwait([refresh])
        setNameReserve('')
        setHashItemReserve('')
        setOpenMoveModal(false)
        setReservationNumberMove('')
        setLoadingMoveItem(false)
      }
    }
  }

  const getLabel = (product) => {
    try {
      if (product?.id_detail) {
        const label = getAirports(product?.segments?.[0]?.itineraryGroup)
        if (label) {
          return label
        }
      }
      return 'ERROR'
    } catch (error) {
      return 'ERROR'
    }
  }

  if (air) {
    return (
      <>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loadingDeleteItem || loadingRetriveItem || loadingVoidItem}>
          <CircularProgress color='inherit' />
        </Backdrop>

        <TabProduct
          products={air}
          labelGetter={(product) => getLabel(product)}
          getStyle={(product) => (getLabel(product) == 'ERROR' ? { color: 'red' } : null)}
        >
          {!editMode && (
            <ToolbarReservation
              resource='air-detail'
              reservation={reservation}
              loadingCancel={loadingCancelItem}
              onCancel={(air) => {
                setOpen(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              onDeleted={(air) => {
                setOpenDeleteModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingDeleteItem={loadingDeleteItem}
              onGuaranteed={(air) => {
                setOpenGuaranteeModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingGuaranteeItem={loadingGuaranteeItem}
              onMove={(air) => {
                setOpenMoveModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingMoveItem={loadingMoveItem}
              onClone={(air) => {
                setOpenCloneModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingCloneItem={loadingCloneItem}
              onEmit={(air) => {
                setOpenEmitModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              loadingEmitItem={loadingEmitItem}
              onRetrive={(air) => {
                setOpenRetriveModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              onVoid={(air) => {
                setOpenVoidModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }}
              setOpenProductModal={setOpenProductModal}
              onAfterSales={(air) => {
                setOpenAfterSalesModal(true)
                setHashItemReserve(air?.hash_)
                setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
              }
              }
              setLoadingMoveItem={setLoadingMoveItem}
              loadingAfterSales={loadingAfterSalesItem}
              setLoadingAfterSalesItem={setLoadingAfterSalesItem}
              onRegisterReturn={
                (air) => {
                  setOpenRegisterReturnModal(true)
                  setHashItemReserve(air?.hash_)
                  setNameReserve(getAirports(air?.segments?.[0]?.itineraryGroup))
                }
              }
              loadingRegisterReturn={loadingRegisterReturnItem}
              setLoadingRegisterReturn={setLoadingRegisterReturnItem}
              postventaStatusButton={(air) => {
                setChangePostventaStatus(true)
                setHashItemReserve(air?.hash_)
                setActualStatus(air.status)
              }}
              loadingPostventaStatus={loadingPostventaStatus}
              onAfterSalesItem={(air) => {
                setOpenAfterSalesItemModal(true)
                setHashItemReserve(air?.hash_)
              }
              }
              onComplementary={(air) => {
                setOpenComplementaryModal(true)
                setHashItemReserve(air?.hash_)
              }}
              loadingComplementaryItem={loadingComplementaryItem}
              onItemSupplierCreate={(air) => {
                setItemSupplierItemId(air?.item_id ?? air?.id)
                setOpenCreateItemSupplierModal(true)
              }}
            />
          )}

          <Box display={'flex'}>
            <div className='responsive-products-info'>
              <WrapperCardId>
                <ContextAirForm
                  reservation={reservation}
                  openProductModal={openProductModal}
                  onSubmitProduct={(data, cardId) => onSubmitProduct(data, cardId)}
                  setOpenProductModal={setOpenProductModal}
                />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={12} xl={8}>
                    <ReserveInformation 
                      reservation={reservation} 
                      refresh={refresh}
                      isBillable={isBillable}
                      hashItemReserve={hashItemReserve}
                      setHashItemReserve={setHashItemReserve}
                      setIsBillable={setIsBillable}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.cancel_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpen}
                      setConfirm={setConfirm}
                      open={open}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.delete_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenDeleteModal}
                      setConfirm={setConfirmDelete}
                      open={openDeleteModal}
                      loadingModalButton={loadingDeleteItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.guarantee_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenGuaranteeModal}
                      setConfirm={setConfirmGuarantee}
                      open={openGuaranteeModal}
                      loadingModalButton={loadingGuaranteeItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.clone_reservation', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenCloneModal}
                      setConfirm={setConfirmClone}
                      open={openCloneModal}
                      loadingModalButton={loadingCloneItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.after_sales', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesModal}
                      setConfirm={setConfirmAfterSales}
                      open={openAfterSalesModal}
                      loadingModalButton={loadingAfterSalesItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.new_after_sales_item_confirmation')}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesItemModal}
                      setConfirm={setConfirmAfterSalesItem}
                      open={openAfterSalesItemModal}
                      loadingModalButton={loadingAfterSalesReservationItem}
                    />
                    <CreateItemSupplierModal
                      open={openCreateItemSupplierModal}
                      itemId={itemSupplierItemId}
                      onClose={() => setOpenCreateItemSupplierModal(false)}
                    />
                    <ComplementaryItemModal
                      open={openComplementaryModal}
                      hashItem={hashItemReserve}
                      onClose={() => setOpenComplementaryModal(false)}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.register_return', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRegisterReturnModal}
                      setConfirm={setConfirmRegisterReturn}
                      open={openRegisterReturnModal}
                      loadingModalButton={loadingRegisterReturnItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.emit_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenEmitModal}
                      setConfirm={setConfirmEmit}
                      open={openEmitModal}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.refresh_retrive_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRetriveModal}
                      setConfirm={setConfirmRetrive}
                      open={openRetriveModal}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.refresh_void_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenVoidModal}
                      setConfirm={setConfirmVoid}
                      open={openVoidModal}
                    />
                    {/* <ConfirmationDialog
                      title={approveFraud ? translate('ra.message.approve_fraud') : translate('ra.message.refuse_fraud')}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenFraudModal}
                      setConfirm={setConfirmFraud}
                      open={openFraudModal}
                    /> */}
  
                    <Dialog fullWidth maxWidth={'lg'} open={historyCostsDialog} onClose={() => setHistoryCostsDialog(false)}>
                      <DialogTitle style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>{translate('ra.title.price_history')}
                        <CloseIcon style={{ cursor: 'pointer' }} onClick={() => { setHistoryCostsDialog(false) }} />
                      </DialogTitle>
                      <DialogContent>
                        <HistoryCostsDialog />
                      </DialogContent>
                    </Dialog>

                    <Dialog open={openMoveModal} onClose={() => setOpenMoveModal(false)}>
                      <DialogTitle>Mover item</DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <EditInputsWrap
                            label={translate('ra.field.reservation_number')}
                            md={12}
                            lg={12}
                            style={{ minHeight: 0 }}
                          >
                            <TextField
                              value={reservationNumberMove}
                              onChange={(e) => setReservationNumberMove(e.target.value)}
                              size='small'
                              fullWidth
                            />
                          </EditInputsWrap>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant='outlined'
                          onClick={() => {
                            setNameReserve('')
                            setHashItemReserve('')
                            setReservationNumberMove('')
                            setOpenMoveModal(false)
                          }}
                        >
                          Cancelar
                        </Button>
                        <LoadingButton loading={loadingMoveItem}  variant='contained' onClick={handleMoveItem}>
                          Aceptar
                        </LoadingButton>
                      </DialogActions>
                    </Dialog>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12} xl={4}>
                    <WrapperCardId>
                      <ContactModal
                        open={openContactModal}
                        loadingButton={loadingContactModal}
                        handleClose={() => setOpenContactModal(false)}
                        onSubmit={(record, cardId) => {
                          handleUpdateContact(
                            record,
                            cardId,
                            setLoadingContactModal,
                            setOpenContactModal,
                            notify,
                            refresh,
                            setCardLoading
                          )
                        }}
                        titleModal={translate('ra.title.update_contact')}
                      />
                      <ShowCard
                        iconHeader={<PhoneIcon />}
                        title={translate('ra.title.contanct')}
                        actionButtonIcon={!editMode && <EditIcon />}
                        variant='text'
                        onClickButton={() => {
                          setOpenContactModal(true)
                        }}
                      >
                        <CompleteSideCard>
                          <ShowElement source='contact.name' label={translate('ra.field.name')} />
                          <ShowElement source='contact.surname' label={translate('ra.field.surname')} />
                          <ShowElement source='contact.email' label={translate('ra.field.email')} />
                          <ShowElement
                            source='contact.phone_number'
                            label={translate('ra.field.phone_number')}
                          />
                        </CompleteSideCard>
                      </ShowCard>
                    </WrapperCardId>

                    <WrapperCardId>
                      <ObservationsCard />
                    </WrapperCardId>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ShowCard
                      iconHeader={<AirplanemodeActiveIcon />}
                      title={translate('ra.title.aerial_information')}
                    >
                      <CompleteSideCard>
                        <Box display={'flex'}>
                          <LeftSideCard>
                            <ShowElement source='airline' label={translate('ra.field.airline')} />
                            <ShowElement source='gds' label={translate('ra.field.gds')} />
                            <ShowElement source='pnr_code' label={translate('ra.field.pnr')} />
                            <IsCabotage />
                            <HasMetaCode />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement source='type' label={translate('ra.field.type')} />
                            <ShowElement source='office' label={translate('ra.field.id_issue_office')} />
                            <HasFareCode />
                          </RigthSideCard>
                        </Box>
                        <ContextAir reservation={reservation} />
                      </CompleteSideCard>
                    </ShowCard>
                  </Grid>
                </Grid>
              </WrapperCardId>
              <FlexibleRateCard />
              <ServicePackageCard />

              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ShowCard
                      title={translate('ra.title.promotions')}
                    >
                      <CompleteSideCard>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                          {air[0].promotions.map((promo, index) => (
                            <Chip 
                              key={promo.id || index}
                              label={promo.label}
                              sx={{ 
                                backgroundColor: 'orange',
                                color: 'white',
                                fontWeight: 500,
                                borderRadius: '10px',
                                padding: '2px 7px',
                                fontSize: 14
                              }}
                            />
                          ))}
                        </Box>
                      </CompleteSideCard>
                    </ShowCard>
                  </Grid>
                </Grid>
              </WrapperCardId>

              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <HepstarServicesCard />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <NotificationEmails />
                  </Grid>
                </Grid>
              </WrapperCardId>

              <HasPermission resource='file-upload' permission={PERMISSION_GET}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FilesCard />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
              <HasPermission permission={PERMISSION_SHOW} resource={'comments'}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <CommentsCardComponent />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
            </div>
            <div className='responsive-products-pricing'>
              <Box
                style={{
                  position: 'sticky',
                  top: '10px',
                  zIndex: '1000',
                  '&.MuiPaper-root': {
                    overflow: 'visible !important',
                  },
                }}
              >
                <WrapperCardId>
                  {/* <ShowCard
                    iconHeader={<AttachMoneyIcon />}
                    title={translate('ra.title.pricing')}
                    optionHeigth={'pricing'}
                    actionButtonIcon={<EditIcon />}
                    variant='text'
                    onClickButton={() => {
                      setOpenPricingModal(true)
                    }}
                  >
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <Pricing />
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </ShowCard> */}
                </WrapperCardId>
                <WrapperCardId>
                  <PricingAirModal
                    open={openPricingModal}
                    loadingButton={loadingPricingModal}
                    handleClose={() => setOpenPricingModal(false)}
                    onSubmit={(record, cardId) => {
                      handleUpdatePricing(
                        record,
                        cardId,
                        setLoadingPricingModal,
                        setOpenPricingModal,
                        notify,
                        refresh,
                        setCardLoading,
                        reservation
                      )
                    }}
                    titleModal={translate('ra.title.update_pricing')}
                  />
                  {!editMode && (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                      <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                        <HasPermission permission='revision' resource={'pricing'}>
                          <Button
                            onClick={() => { setHistoryCostsDialog(true) }}
                            sx={{ paddingX: '10px', marginX: '5px' }}
                            size='small'
                            variant='contained'
                          >
                            {translate('ra.title.price_history')}
                          </Button>
                        </HasPermission>
                      </Box>
                      <EditOriginValues setEnableReliquidation={setEnableReliquidation} isBillable={isBillable} setOpenPricingModal={setOpenPricingModal} />
                    </div>
                  )}

                  {/* <LiquidationModal
                    open={openLiqudiationPricingModal}
                    loadingButton={loadingLiqudiationPricingModal}
                    handleClose={() => {
                      setOpenLiqudiationPricingModal(false)
                      setExchangeMode(false)
                    }}
                    exchange_mode={exchangeMode}
                    onSubmit={(body, cardId) => {
                      handleUpdateLiquidation(
                        individualRecord,
                        body,
                        cardId,
                        setLoadingLiqudiationPricingModal,
                        setOpenLiqudiationPricingModal,
                        notify,
                        refresh,
                        setCardLoading
                      )
                      setExchangeMode(false)
                    }}
                    titleModal={translate('ra.title.update_liquidation')}
                  /> */}
                  <LiquidationCards enableReliquidation={enableReliquidation} />
                </WrapperCardId>
              </Box>
            </div>
          </Box>
        </TabProduct>
      </>
    )
  }
}
